import store from '@/store/store';
import { CheckField, Consent, ConsentResponse } from '@/types/types';
import { getConsentText, getUserConsent } from './apiService';
import { Log } from '@/appinsights/logging/log';
import { POLICY_FIELDS, PROPOSAL_STEPS } from '@/types/enums';
import { UPDATE_TEXT_ONLY_FIELD_VALUE } from '@/store/modules/ProposalContext';
import { isDevelop } from './environmentService';

export const updateConsentFromApi = async (): Promise<void> => {
	try {
		const consentResponse: any = await getConsentText();
		if (consentResponse?.status === 'TEST_DATA') {
			Log.exception('fail consent TEST_DATA LOADED', undefined, {
				quoteId: store.state.ProposalContext.quote_id,
			});
		} else if (consentResponse?.status !== 200) {
			Log.exception('fail consent', undefined, { quoteId: store.state.ProposalContext.quote_id });
			// KLK ERROR
			return;
		}
		const consentData: ConsentResponse = consentResponse;

		for (const consent of consentData?.data || []) {
			if (consent?.businessName?.toUpperCase()?.startsWith('PROMOTION EMAIL')) {
				// get content from consent and put in samtykke_content1 field
				// const field = inputFields?.find((field) => field.id === POLICY_FIELDS.samtykke_content1);

				await store.dispatch(UPDATE_TEXT_ONLY_FIELD_VALUE, {
					id: POLICY_FIELDS.samtykke_content1,
					value: consent.consentText,
				});
				break;
			}
		}

		const userConsent = await getUserConsent();
		let mocked: string;
		if (userConsent?.status === 'TEST_DATA' && isDevelop) {
			mocked = ' (Mocked)';
		}
		// KLK We cannot yet get the consent the customer might already have.
		const inputFields = store.state.ProposalContext.proposalSteps.get(PROPOSAL_STEPS.consentBlock)?.inputFields;

		userConsent.consents.forEach((consent: Consent) => {
			const field = inputFields.find((field: CheckField) => field.id === consent.consent_type);
			if (field) {
				// don't use consent.consent_text, since the text for all consents is identical and way too large
				if (mocked) {
					field.postLabel = `${field.postLabel} ${mocked}`;
				}

				field.value = consent.is_accepted;
				if (consent.is_accepted) {
					// KLK Hack, we cannot now update existing accepted consents
					field.readonly = true;
				}
			} else {
				Log.exception('Field ' + consent.consent_type + ' is not present in CMS', undefined, {
					quoteId: store.state.ProposalContext.quote_id,
				});
			}
		});
	} catch (e) {
		Log.exception('Error updating consent from API', e, { quoteId: store.state.ProposalContext.quote_id });
	}
};

export const createConsentBody = (): { consents: Array<Consent> } => {
	const inputFields = store.state.ProposalContext.proposalSteps.get(PROPOSAL_STEPS.consentBlock)?.inputFields;

	const consents: Array<Consent> = [];
	const consentBody = { consents };

	inputFields?.forEach((field: CheckField) => {
		// only send fields that have been selected
		if (field?.masterId && !field.readonly && field.value) {
			const consent: Consent = {
				consent_type: field.id,
				is_accepted: field?.value ? (field?.value as boolean) : false,
			};
			consents.push(consent);
		}
	});
	return consentBody.consents?.length > 0 ? consentBody : undefined;
};
